import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ClientModel } from '../models/client.model';

@Injectable()
export class ClientService {
    constructor(private http: HttpClient, @Inject('API_BASE_URL') private baseUrl: string) { }

    all(): Promise<any> {
        let url = this.baseUrl + 'clients';

        let promise = new Promise((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var clientData = (res as ClientModel);
                    resolve(clientData);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "client request failed"
                    });
                });
        });

        return promise;
    }

}

